export { EnsureSafeComponentHelper as default } from '@embroider/util';
